




























import Vue from 'vue';
import { Document } from '../types';
import { isApproved } from '.';
import EditorToolbar from '../editor/EditorToolbar.vue';
import DocumentLabelTag from './DocumentLabelTag.vue';
import SubmitDocumentBtn from './SubmitDocumentBtn.vue';
import ApproveDocumentBtn from './ApproveDocumentBtn.vue';
import DocumentStatus from './DocumentStatus.vue';

export default Vue.extend({
  components: {
    EditorToolbar,
    DocumentLabelTag,
    SubmitDocumentBtn,
    ApproveDocumentBtn,
    DocumentStatus,
  },
  props: {
    document: {
      type: Object as () => Document,
      required: true,
    },
    editorToolbarId: String,
  },
  computed: {
    isApproved(): boolean {
      return isApproved(this.document);
    },
  },
});
